package com.yendo.mx.utils

import androidx.compose.runtime.Composable

@Composable
actual fun rememberMediaPermissionManager(onCameraResult: (ByteArray?) -> Unit): MediaPermissionManager {
    return object : MediaPermissionManager {
        override fun requestCameraPermission() {
            onCameraResult(null)
        }

        override fun requestGalleryPermission(onGranted: () -> Unit) {
            onGranted()
        }
    }
}
